import React from 'react'

import { Container, PageHeader, PageTitle, Spinner } from './index.js'

const PageSpinner = (props) => (
  <div>
    <PageTitle title={props.title} />
    <PageHeader title={props.title} />

    <Container fluid>
      <Spinner large />
    </Container>

  </div>
)

export default PageSpinner



// WEBPACK FOOTER //
// ./client/src/components/PageSpinner.js